<template>
<div>
    <Breadcrumbs main="Admin" title="Announcement Create" />
    <!-- Container-fluid starts-->
    <div class="container-fluid">
        <div class="row">
            <div class="col-sm-12">
                <px-card>
                    <div slot="with-padding">
                        <div class="form theme-form">

                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label>Date <span style="color: red;">*</span></label>
                                        <datepicker placeholder="Select a date" input-class="datepicker-here form-control digits" ref="datepicker" v-model="details.date"></datepicker>
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label>Title</label>
                                        <input class="form-control" type="text" placeholder="Enter announcement title" v-model="details.title">
                                    </div>
                                </div>

                            </div>

                            <div class="row">
                                <div class="col">
                                    <div class="form-group">
                                        <label>Announcement</label>
                                        <textarea class="form-control" placeholder="Enter announcement description..." rows="5" v-model="details.announcement">  </textarea>

                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label>Image</label>
                                        <div class="flex items-center">
                                            <input type="file" accept="image/*" @change="uploadFile">
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                 <div class="col-sm-6">
                                    <div class="form-group">
                                        <label>Redirection Link</label>
                                        <input class="form-control" type="text" placeholder="Enter redirection link" v-model="details.link">
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-1">
                                <div class="col">
                                    <label class="font-weight-bold">Steps</label>
                                </div>
                            </div>

                            <div v-for="(reel, index) in details.reels" :key="index" style="margin-bottom: 16px;">
                                <!-- Title -->
                                <div class="row">
                                    <div class="col-md-3">
                                        <div class="form-group">
                                            <label>Title</label>
                                            <input type="text" class="form-control" v-model="reel.title" placeholder="Enter title..." />
                                        </div>
                                    </div>

                                    <!-- Link -->
                                    <div class="col-md-4">
                                        <div class="form-group">
                                            <label>Link</label>
                                            <input type="text" class="form-control" v-model="reel.link" placeholder="Enter link..." />
                                        </div>
                                    </div>

                                    <!-- Image -->
                                    <div class="col-md-4">
                                        <div class="row">
                                            <div class="col-12">
                                                <div class="form-group">
                                                    <label>Image</label>
                                                    <input type="file" class="form-control" @change="onFileChange($event, index)" />
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>

                                <!-- Add/Delete -->

                                <div class="row">
                                    <div class="col-md-6 d-flex align-items-end" style="gap:16px">
                                        <feather type="plus" size="22px" style="color: #2563eb; cursor: pointer;" v-b-tooltip.hover v-b-modal.modal-center-details title="Add more" @click="addReel"></feather>
                                        <feather type="delete" size="22px" style="color: #ef4444; cursor: pointer;" v-b-tooltip.hover v-b-modal.modal-center-details title="Delete" @click="removeReel(index)" v-if="details.reels.length > 1"></feather>

                                    </div>
                                </div>

                            </div>

                            <div class="row" style="margin-top: 20px;">
                                <div class="col">
                                    <div class="form-group mb-0">
                                        <button @click="onSubmit" class="btn btn-success mr-3" :disabled="isDisabled">Create</button>
                                        <router-link to="/admin/announcement">
                                            <button class="btn btn-danger" href="#">Go Back</button>
                                        </router-link>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </px-card>
            </div>
        </div>
    </div>
    <!-- Container-fluid Ends-->
</div>
</template>

<script>
import {
    mapState
} from 'vuex';
import Datepicker from 'vuejs-datepicker';
import vue2Dropzone from 'vue2-dropzone';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';
import moment from "moment";
import Multiselect from 'vue-multiselect';
import 'sweetalert2/src/sweetalert2.scss';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import treeVue from '../../advance/tree.vue';

export default {
    components: {
        vueDropzone: vue2Dropzone,
        Datepicker,
        Multiselect
    },

    data() {
        return {
            isDisabled: false,
            editor: ClassicEditor,
            details: {
                date: null,
                title: null,
                announcement: null,
                image: null,
                link:null,
                reels: [{
                    title: '',
                    img: '',
                    link: '',
                }],
            },
            show_images: [],

            statuses: [{
                    label: 'Yes',
                    value: true
                },
                {
                    label: 'No',
                    value: false
                }
            ],

        };
    },

    computed: {

    },

    mounted() {

    },

    methods: {

        addReel() {
            this.details.reels.push({
                title: "",
                img: "",
                link: "",
            });
        },

        removeReel(index) {
            this.details.reels.splice(index, 1);
        },

        onFileChange(event, index) {
            const image = event.target.files[0];
            if (!image) return;
            const reader = new FileReader();
            reader.readAsDataURL(image);
            reader.onload = e => {
                // this.show_images[index] = e.target.result;
                this.details.reels[index].img = e.target.result;
            };

        },

        uploadFile(e) {
            const image = e.target.files[0];
            const reader = new FileReader();
            reader.readAsDataURL(image);
            reader.onload = e => {

                this.details.image = e.target.result;
            };
        },

        onSubmit() {
            this.isDisabled = true
            if (this.details.date !== null) {
                this.details.date = moment(String(this.details.date)).format("YYYY-MM-DD");
            }

            this.$store.dispatch("announcement/addannouncement", {
                announcement: this.details,
            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });
                    this.isDisabled = false,
                    this.show_images = []
                    this.details.date = null,
                    this.details.title = null,
                    this.details.image = null,
                    this.details.announcement = null,
                    this.details.link = null,
                        this.details.reels = [{
                            title: "",
                            img: "",
                            link: "",
                        }]

                    setTimeout(() => {
                        this.$router.push('/admin/announcement')
                    }, 2000)

                } else {
                    this.isDisabled = false
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }

            })
        }
    }
};
</script>
